"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggle = toggle;

var _noty = require("noty");

var _promisePolyfill = babelHelpers.interopRequireDefault(require("promise-polyfill"));

var _LoginForm = require("components/LoginForm");

var _userProfile = require("user-profile");

function toggle() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : void 0;
  return new _promisePolyfill.default(function (resolve) {
    var loc = location.href.split('?').shift();
    var xhr = new XMLHttpRequest();
    xhr.open('POST', loc, true);
    xhr.setRequestHeader('Content-Type', 'application/json');

    xhr.onreadystatechange = function () {
      if (xhr.readyState == 4) {
        var d = JSON.parse(xhr.responseText);

        if (d.login) {
          (0, _LoginForm.show)().then(function () {
            toggle(true).then(resolve);
          });
          return;
        }

        (0, _userProfile.userProfileUpdated)().then(function (profile) {
          (0, _noty.showNotificationText)(d.active ? "Added ".concat(d.title, " to your Favorites.") : "Removed ".concat(d.title, " from your favorites."));
          resolve(d);
        });
      }
    };

    var arg = {};
    if (value === void 0) arg.toggleBookmark = true;else arg.setBookmark = value;
    xhr.send(JSON.stringify(arg));
  });
}